import { render, staticRenderFns } from "./QuestionCircle.vue?vue&type=template&id=d424e4da&scoped=true"
import script from "./QuestionCircle.vue?vue&type=script&lang=js"
export * from "./QuestionCircle.vue?vue&type=script&lang=js"
import style0 from "./QuestionCircle.vue?vue&type=style&index=0&id=d424e4da&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d424e4da",
  null
  
)

export default component.exports